<script>
import Input from "@/components/c-input";
// import Select from "@/components/c-select";
// import i18n from "../../i18n";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    Input,
    // Select,
  },
  data() {
    return {

      valueLabel: '',
      valueId: 0,
      valueQuantity: 0,
      valuePrice: 0


    };
  },
  mounted() {

    if(this.item != null) {
      this.valueQuantity = this.item.quantity;
      this.valuePrice = this.item.price;
    }

  },
  methods: {
    
    getValue: function() {
      return this.valueAmount;
    },

    setValue: function(value) {
      console.log(value);
      this.valueAmountDisplay = value;
    },

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

    changedValue: function(event) {
      // console.log(event);

      this.item.quantity = event;
      this.$emit('changed', {item: this.item, index: this.index});
    },
    changedPrice: function(event) {
      // console.log(event);

      this.item.price = event;
      this.$emit('changed', {item: this.item, index: this.index});
    },
    removeValue: function() {
      this.$emit('deleted', {index: this.index});
    }
    
  },
  props: {
    item: null,
    index: {
      type: Number,
      default: 0
    },
    disable: {
      type: Boolean,
      default: false
    },
    isRequest: {
      type: Boolean,
      default: false
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-md-5" style="margin-top: 7px;">{{item.label}}</div>
    <div class="col-md-2">
      <Input 
        v-on:input="changedValue"
        :type="'number'"
        :id="`quantity_${index}`"
        :disabled="disable"
        v-model="valueQuantity" /> 
    </div>
    <!-- <div class="col-md-2 text-end" style="margin-top: 7px;">{{formatCurrency(item.price, '$')}}</div> -->
    <div class="col-md-2 text-end" v-show="!isRequest">
      <Input 
        v-on:input="changedPrice"
        :type="'number'"
        :id="`price_${index}`"
        :disabled="disable"
        v-model="valuePrice" /> 
    </div>
    <div v-show="!isRequest" class="col-md-2 text-end" style="margin-top: 7px;">{{formatCurrency(item.price * valueQuantity, '$')}}</div>
    <div :class="isRequest ? 'col-md-5 text-center contact-links mb-0 pagination-rounded' : 'col-md-1 text-center contact-links mb-0 pagination-rounded'">
      <div class="row">
        <div class="col-md-3"></div>
        <div v-show="disable == false" class="col-md-6">
          <a href="#" @click="removeValue" v-b-tooltip.hover :title="$t('general.remove')" class="page-link bg-danger">
            <i class="bx bx-trash" style="color: white; margin-top: 5px"></i>
          </a>
        </div>
        <div class="col-md-3"></div>
      </div>
    </div>
  </div>
</template>